<template>
  <div>
      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">



                <h2 class="block-title" style="font-size:18px" @click="selectThisSubBundle()"><i class="fa fa-usb fa-1x push-5-r "></i>{{subBundleIndex+1}}:{{actualBundle.sub_bundle[subBundleIndex].ReferenceName}}</h2>
            

                <div v-if="flagDisplayPowerBar && actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable" class="row">
                    <hr></hr>
                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarData5Min" ></relative-power-bar>
                    </div>
                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_001H" ></relative-power-bar>
                    </div>
                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_004H" ></relative-power-bar>
                    </div>
                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_006H" ></relative-power-bar>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_012H" ></relative-power-bar>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_024H" ></relative-power-bar>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_072H" ></relative-power-bar>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_168H" ></relative-power-bar>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_336H" ></relative-power-bar>
                    </div>

                    <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H" class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                      <relative-power-bar v-if="flagDisplayPowerMA " :barData="powerBarDataMA_720H" ></relative-power-bar>
                    </div>
                </div>
              </div>                                                        

              <div v-if="actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag" class="block-content">
                <div class="row">
                  <div v-for = "(attribute ,index) in actualBundle.sub_bundle[subBundleIndex].Attributes">
                    <div v-if="actualBundle.sub_bundle[subBundleIndex].Attributes[index] != 'ND'" class="col-xm-6 col-sm-4 col-md-2">
                      
                      <button  class="btn btn-xs btn-default" type="button">{{actualBundle.sub_bundle[subBundleIndex].Attributes[index]}}</button>
                    </div>
                  </div>
                </div>
              </div>



            </div>
        </div>
      </div>
      </div>
    </div>
    
  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import RelativePowerBar from './SubComponents/RelativePowerBar.vue'



export default {
  props: ['subBundleIndex'],
  components: {
    Spinner,
    RelativePowerBar,
  },

  data() {
    return {
      tempoBundle : {},
      displayDataTable : false,
      flagDisplayChannel : 0,
      flagDisplayGraph : true,
      flagChannelDataIsLoading : true,
      flagDisplayChannelJournal : false,
      flagDisplayPowerBar : true,
      alertShowAddButton: true,
      channelIsSaving : false,
      channelIsDeleting : false,
      alertIsCreating : false,
      channelReadings : [],
      totalPower : 0,
      peakCurrent : 0,
      totalCost : 0,

      flagDisplayPowerMA : true,
      powerBarDataWk : {Label:'Dernière semaine', PreviousText:'Semaine', Value:10, Max:20, AfterText:' kWh'},
      powerBarDataDay : {Label:'Dernier jour', PreviousText:'Jour', Value:5, Max:20, AfterText:' kWh'},
      powerBarDataHr : {Label:'Dernière heure', PreviousText:'Heure', Value:16, Max:20, AfterText:' kW'},
      powerBarData5Min : {Label:'Dernière mesure', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_001H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_004H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_006H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_012H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' W'},
      powerBarDataMA_024H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_072H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_168H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_336H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},
      powerBarDataMA_720H : {Label:'Moyenne 1Hr', PreviousText:'5 Min', Value:19, Max:20, AfterText:' kW'},




      //labelGraphPeakCurrent: {FR: 'Courant maximum', EN: 'Max current'},
      //labelGraphCost: {FR: 'Coût', EN: 'Cost'},
      //labelGraphSaving: {FR: 'Économies', EN: 'Savings'},
      //labelGraphConsumption: {FR: 'Consommation', EN: 'Consumption'},

      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},
    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','actualBundleChannelMaximums','displayAllChannelGraphFlag']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },
  watch: {
    actualBundle(){
        this.reloadTempoBundle()

        this.$nextTick(() => {
          this.flagDisplayGraph = true
        });
        
    },
    displayAllChannelGraphFlag(){
        //console.log('---DisplayChannel:Watcher Display all channel-----')
        if(this.displayAllChannelGraphFlag){
          //this.flagChannelDataIsLoading = false
        }else{
          //this.flagChannelDataIsLoading = true
        }
    },
    actualBundleChannelMaximums(){
      this.flagDisplayPowerBar = false
      this.refreshPowerBar()
      this.flagDisplayPowerBar = true
      //console.log('---DisplayChannel:Actual Bundle Channel Maximums-----')
      //console.log(this.actualBundleChannelMaximums)
      
    },


  },

  methods: {
  
   selectThisSubBundle(){

        console.log('===TO BE IMPLEMENTED====')
        //this.$store.dispatch('sessionStore/setActualBundle', JSON.parse(JSON.stringify(this.actualBundle)))
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
        //this.$store.dispatch('devicesStore/reset')
    },



    refreshPowerBar(){
        //console.log('Refresh Power Bar:' + this.channelIndex)
        //{'5min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0}
        this.powerBarData5Min = {Label:'Mesure actuelle',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['5min'],
                                Max:this.actualBundleChannelMaximums['5min'],
                                AfterText:' W'}

        this.powerBarDataMA_001H = {Label:'Moyenne 1 hr',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_001H'],
                                Max:this.actualBundleChannelMaximums['MA_001H'],
                                AfterText:' W'}

        this.powerBarDataMA_004H = {Label:'Moyenne 4 hrs',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_004H'],
                                Max:this.actualBundleChannelMaximums['MA_004H'],
                                AfterText:' W'}

        this.powerBarDataMA_006H = {Label:'Moyenne 6 hrs',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_006H'],
                                Max:this.actualBundleChannelMaximums['MA_006H'],
                                AfterText:' W'}

        this.powerBarDataMA_012H = {Label:'Moyenne 12 hrs',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_012H'],
                                Max:this.actualBundleChannelMaximums['MA_012H'],
                                AfterText:' W'}

        this.powerBarDataMA_024H = {Label:'Moyenne 1 jr',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_024H'],
                                Max:this.actualBundleChannelMaximums['MA_024H'],
                                AfterText:' W'}

        this.powerBarDataMA_072H = {Label:'Moyenne 3 jrs',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_072H'],
                                Max:this.actualBundleChannelMaximums['MA_072H'],
                                AfterText:' W'}

        this.powerBarDataMA_168H = {Label:'Moyenne 7 jrs',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_168H'],
                                Max:this.actualBundleChannelMaximums['MA_168H'],
                                AfterText:' W'}

        this.powerBarDataMA_336H = {Label:'Moyenne 14 jrs',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_336H'],
                                Max:this.actualBundleChannelMaximums['MA_336H'],
                                AfterText:' W'}

        this.powerBarDataMA_720H = {Label:'Moyenne 30 jrs',
                                PreviousText:'',
                                Value:this.actualBundle.sub_bundle[this.subBundleIndex].lastMeasure['MA_720H'],
                                Max:this.actualBundleChannelMaximums['MA_720H'],
                                AfterText:' W'}

    //{'5min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0}
    }


  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    this.refreshPowerBar()

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
  },


  beforeMount(){
    this.reloadTempoBundle()
    this.refreshPowerBar()
    //console.log('---TEMPO BUNDLE----')
    //console.log(this.tempoBundle.channels[this.channelIndex])
    //console.log(this.tempoBundle.channels[this.channelIndex].ChannelData.DisplayOpenFlag)
    //console.log('---DisplayChannel: Mount: index:' +this.channelIndex)
    

  }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// DisplaySubBundle.vue?8eaf13ce